import { gql } from "@apollo/client";
import type { MockedResponse } from "@apollo/client/testing";

export const GET_USER_STATUSES = gql`
  query get_user_statuses {
    get_user_statuses
  }
`;

export const GET_PROVIDERS = gql`
  query {
    ticket_providers {
      edges {
        node {
          id
          type
          known_identifier
          is_installed
        }
      }
    }
  }
`;

export const GET_ACTUAL_STATUS_VALUES = gql`
  query getStatuses($filterName: String = "actual_status") {
    finding_filter_data(filter_name: $filterName) {
      values
      field
    }
  }
`;

interface GenerateMockOptions {
  result?: Record<string, unknown> | null;
  error?: Error | null;
}

export const generateGetProvidersMock = ({
  result = null,
  error = null,
}: GenerateMockOptions): MockedResponse => {
  let getFindingsByGroupMock: MockedResponse = {
    request: {
      query: GET_PROVIDERS,
    },
  };

  if (error) {
    return {
      ...getFindingsByGroupMock,
      error: error,
    };
  }

  if (result) {
    return {
      ...getFindingsByGroupMock,
      result: { data: result },
    };
  }

  return {
    ...getFindingsByGroupMock,
    result: {},
  };
};
